import { render } from "./SkeletonLoading.vue?vue&type=template&id=5b95646c&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"

import "./SkeletonLoading.vue?vue&type=style&index=0&id=5b95646c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b95646c"]])

export default __exports__